import IconButton from '@components/v2/ui/IconButton/IconButton';
import Loading from '@components/v2/ui/Loading/Loading';
import { Box } from '@mui/material';
import { X } from 'lucide-react';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../translation/TranslationContext';
import { RachelAttachment } from '../../../../rachel.files.types';
import { useRachelAttachmentThumbnailStyles } from './rachelAttachmentThumbnail.styles';
import { useRachelAttachmentPreview } from './useRachelAttachmentPreview';

const PROGRESS_SIZE = 16;

interface RachelAttachmentThumbnailProps {
  attachment: RachelAttachment;
  onRemove: (id: string) => void;
}

const RachelAttachmentThumbnail = ({ attachment, onRemove }: RachelAttachmentThumbnailProps) => {
  const { translate } = useTranslation();
  const { classes } = useRachelAttachmentThumbnailStyles();
  const imageRef = useRachelAttachmentPreview(attachment.file);

  return (
    <Box test-id="rachel-attachment-thumbnail" className={classes.thumbnail}>
      <img ref={imageRef} alt={attachment.file.name} className={classes.image} />
      {attachment.status === 'uploading' && (
        <Box className={classes.scrim}>
          <Loading size={PROGRESS_SIZE} color="inherit" />
        </Box>
      )}
      <IconButton
        icon={X}
        size="small"
        shape="round"
        className={classes.removeButton}
        ariaLabel={translate(LangEnum.RACHEL_ATTACHMENT_REMOVE)}
        onClick={() => onRemove(attachment.id)}
      />
    </Box>
  );
};

export default RachelAttachmentThumbnail;
